/**
 * Campo de texto de um dado do posto: rótulo fixo fora do campo, exemplo na ajuda e erro (do cliente
 * ou do servidor) logo abaixo. Edita o rascunho do Wizard pelo nome do campo.
 */
import React from 'react';
import { Grid, TextField } from '@mui/material';
import type { WizardStepProps, WorkstationDraft } from './Wizard.types';

type WorkstationTextFieldName = Exclude<keyof WorkstationDraft, 'workPace' | 'riskLevel'>;

interface WorkstationFieldProps extends Pick<WizardStepProps, 'values' | 'errors' | 'onChange' | 'canEdit' | 'disabled'> {
  field: WorkstationTextFieldName;
  label: string;
  /** Exemplo ou instrução curta, mostrado enquanto não há erro. */
  help?: React.ReactNode;
  required?: boolean;
  multiline?: boolean;
  /** Largura em colunas no desktop (de 12). */
  md?: number;
  inputMode?: 'text' | 'numeric' | 'decimal';
}

export const WorkstationField: React.FC<WorkstationFieldProps> = ({
  field,
  label,
  help,
  required,
  multiline,
  md = 12,
  inputMode,
  values,
  errors,
  onChange,
  canEdit,
  disabled,
}) => (
  <Grid size={{ xs: 12, md }}>
    <TextField
      fullWidth
      required={required}
      multiline={multiline}
      minRows={multiline ? 2 : undefined}
      label={label}
      value={values[field]}
      onChange={(event) => onChange({ [field]: event.target.value })}
      error={Boolean(errors[field])}
      helperText={errors[field] || help}
      disabled={disabled}
      slotProps={{ htmlInput: { ...(inputMode ? { inputMode } : {}), readOnly: !canEdit } }}
      sx={{ '& .MuiFormHelperText-root': { fontSize: '1rem' } }}
    />
  </Grid>
);
